import { Base, Text, View } from 'components';
import { Config } from 'components/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';

interface State {
  routes: any;
}

export default class Main extends Base {
  public config: Config = {
    navigationBarTitleText: '页面集合'
  };

  public state: State = {
    routes: [
      {
        tit:'销售工具-saleTool',
        pages:[
          {name: '登录', url: "/saleTool/login"},
          {name: '订单列表', url: "/saleTool/main"}
        ]
      },
      {
        tit:'二手挖机-eswj',
        pages:[
          {name: '加入会员', url: "/payment/eswjVip"},
          {name: '发布工具', url: "/eswj/pubSale"},
          
        ]
      },
      {
        tit:'二手铲车-escc',
        pages:[
          {name: '加入会员', url: "/payment/esccVip"},
        ]
      },
      {
        tit:'维修名片-快修宝-scorponok',
        pages:[
          {name: '加入会员-old', url: "/scorponok/vip"},
          {name: '购买积分-old', url: "/scorponok/scoresRecharge"},
          {name: '加入会员', url: "/payment/repaireVip"},
          {name: '购买积分', url: "/payment/repaireScores"},
          {name: '积分纪录', url: "/scorponok/scoresRecord"},
          {name: '维修课程', url: "/payment/video"},
          {name: '维修课程详情', url: "/payment/videoDetail"},
          {name: '发布视频-还没做好', url: "/scorponok/pubVideo"}
        ]
      },
      {
        tit:'找驾驶员-megatron',
        pages:[
          {name: '积分充值-old', url: "/megatron/scores/recharge"},
          {name: '积分充值', url: "/payment/megatronScoresRecharge"},
          {name: '积分规则', url: "/megatron/scores/rule"},
          {name: '积分规则-新版', url: "/megatron/scores/ruleNew"},
          {name: '招聘置顶', url: "/payment/employToTop"},
          {name: '招聘置顶-选招聘', url: "/payment/selectEmploy"},
          {name: '简历置顶', url: "/payment/resumeList"},
          {name: '替班卡', url: "/payment/tiban"},
        ]
      },
      {
        tit:'驾驶员找活-sixshot',
        pages:[
          {name: '积分充值-old', url: "/sixshot/scores/recharge"},
          {name: '积分充值-payment', url: "/payment/SixshotScoresRecharge"},
          {name: '替班卡-payment', url: "/payment/SixshotScoresRecharge?type=ti"},
          {name: '积分规则', url: "/sixshot/scores/rule"},

          {name: '会员对比页-不能支付', url: "/sixshot/vip/compaire"},
          {name: '会员对比页', url: "/payment/sixshotvipcompaire"},
          {name: '会员权益', url: "/sixshot/vip/rights?level=1&column=score"},
          {name: '会员权益介绍', url: "/sixshot/vip/introduce?column=law"},
          {name: '会员-合作申请', url: "/sixshot/vip/adviceApply"}
        ]
      },
      // {
      //   tit:'挖机找活-sixshot_wjzh',
      //   pages:[
      //     {name: '积分充值-payment', url: "/payment/SixshotScoresRecharge"},
      //   ]
      // },
      {
        tit:'51易租',
        pages:[
          {name: '积分充值', url: "/payment/rentScoreRecharge"},
          {name: '会员', url: "/payment/rentvip"},
          {name: '会员-不禁止地区', url: "/payment/rentvipIgnoreArea"},
          {name: '会员详情', url: "/payment/rentvipdetail"},
          {name: '会员对比页', url: "/payment/rentvipcompaire"},
          {name: '会员权益', url: "/rent/vip/rights?level=1&column=score"},
          {name: '招标详情', url: "/rent/tender?id=101&token=e923b0164f21b84f436ea2b01c429842f9ae9c9b4c912f9c093ef74495d30bcf"},
        ]
      },
      {
        tit:'51板车',
        pages:[
          {name: '会员', url: "/payment/trunkvip"},
          {name: '会员详情', url: "/payment/trunkvipdetail"},
          {name: '积分购买', url: "/payment/trunkScoreRecharge"},
        ]
      },
      {
        tit:'故障诊断-scourge- 还没配上去',
        pages:[
          {name: '积分充值', url: "/scourge/scores/recharge"},
          {name: '积分规则', url: "/scourge/scores/rule"}
        ]
      },
      {
        tit:'邀请工具',
        pages:[
          {name: '邀请活动', url: "/invitation_gift"},
          {name: '扫码参与', url: "/subscribe"},
          {name: '已邀请列表', url: "/invitation_gift/list"},
          {name: '保存分享图', url: "/invitation_gift/share_image"},
          {name: '提现', url: "/withdraw"},
          {name: '提现成功', url: "/withdraw/success"}
        ]
      },
      {
        tit:'其他',
        pages:[
          {name: '绑定手机', url: "/bindPhone"},
          {name: '对比工具', url: "/Other/Compaire"},
          {name: '正则转换', url: "/Other/ParseToReact"},
          {name: '跳转小程序', url: '/other/toWeapp?plat_name=jsyzh'},
          {name: '下载APP', url: '/other/downloadApp'},
          {name: '介绍页', url: '/other/help'},
          {name: '意见建议', url: '/other/advice'},
          {name: 'WebView', url: '/other/webview?viewType=appPrivacy'}
        ]
      }
    ]
  };

  public didMount() {
    // this.fetchRecord();
  }

  private link = url => {
    history.push(url);
  }

  public render() {
    const { routes } = this.state;

    return (
      <View className={styles.container}>
        {routes.map((option, index) => {
          return(
            <View className={styles.list} key={'a'+index}>
              <Text className={styles.tit}>{option.tit}</Text>
              {option.pages.map((op,ind) => {
                return(<Text className={styles.lis}  key={'b'+ind} onClick={this.link.bind(this,op.url)}>{op.name} - {op.url}</Text>)
              })}
            </View>
          )
        })}
        <View onClick={this.handleMessage} style={{fontSize: '16px'}}>测试触发小程序跳转</View>
        <View onClick={this.handleMessage1} style={{fontSize: '16px'}}>测试给小程序发送数据</View>
        <View onClick={this.handleDownload} style={{fontSize: '16px'}}>测试下载文件</View>
      </View>
    );
  }

  private handleMessage = () => {
    console.log(window.wx)
    if(window.wx){
      // window.wx.miniProgram.navigateTo({url: '/pages/webview/index?payid=123'})
      window.wx.miniProgram.redirectTo({url: '/pages/webview/index?payid=123'})
    }
    
  }
  private handleMessage1 = () => {
    if(window.wx){
      window.wx.miniProgram.postMessage({ data: {foo: 'bar'} })
    }
    
  }

  // private downloadFile = async() => {
  //   const res = await fetch("https://mydomain.dev.com/export");
  //   const blob = res.blob();
  
  //   download(blob, "file.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");  
  // }
  private handleDownload = () => {
    this.openFile('https://assets.gongji58.com/2021-03-16/2b7ap0agb21615857331.png')
  }
  private openFile = (url) => {
      var link = document.createElement('a');
      link.setAttribute('download', '')
      link.href = url;
      link.target = '_blank';
      link.click();
  }
}
